export class Ciudad {

  ciudId: number;
  codigo: string;
  descripcion: string;
  estado: string;
  fechaCreacion: Date;
  fechaModificacion: Date;
  usuarioCreador: string;
  usuarioModificador: string;
  provId_RepProvincia: number;
  nombreProvincia: string;
  idPais: number;
  nombrePais: string;
  provId: number;  

  constructor() {}

}
